

// import React, { useContext, useState, useRef } from 'react';
// import { PageTitle, Button, Card } from '../components/common';
// import { AuthContext } from '../contexts/AuthContext';
// import { User, Experience, Education } from '../types';
// import { useToast } from '../components/Toaster';

// const DEFAULT_BANNER_URL = "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&w=1920&q=80";
// const DEFAULT_AVATAR_URL = "https://static.vecteezy.com/system/resources/thumbnails/009/292/244/small/default-avatar-icon-of-social-media-user-vector.jpg";

// const EditIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.5L15.232 5.232z" /></svg>;
// const UploadIcon: React.FC<{className?: string}> = ({className = "h-10 w-10 text-gray-400"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" /></svg>;
// const TrashIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>;
// const PencilIcon: React.FC<{ className?: string }> = ({ className = "h-5 w-5" }) => <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.5L15.232 5.232z" /></svg>;
// const CompanyIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-gray-500" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" /></svg>;
// const EducationIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-gray-500" viewBox="0 0 20 20" fill="currentColor"><path d="M10.394 2.08a1 1 0 00-.788 0l-7 3.5a1 1 0 00.788 1.84L10 9.75l6.606-2.25a1 1 0 00.788-1.84l-7-3.5zM3 9.25L10 12l7-2.75v4.5a1 1 0 11-2 0v-2.5L10 12.25 5 10.25v2.5a1 1 0 11-2 0v-4.5z" /><path fillRule="evenodd" d="M10 12.5a1 1 0 00-1 1v3.5a1 1 0 001 1h.5a1 1 0 001-1v-3.5a1 1 0 00-1-1h-.5z" clipRule="evenodd" /></svg>;
// const PlusIcon = () => <svg className="w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" /></svg>;
// const XCircleIcon = () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;

// const EditableItem: React.FC<{ label: string; name: string; value: string; onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void; type?: string; options?: string[]; placeholder?: string; }> = 
// ({ label, name, value, onChange, type = 'text', options, placeholder }) => (
//     <div>
//         <label htmlFor={name} className="block text-sm font-medium text-gray-700">{label}</label>
//         {type === 'select' ? (
//              <select id={name} name={name} value={value} onChange={onChange} className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm rounded-md">
//                 {options?.map(opt => <option key={opt}>{opt}</option>)}
//             </select>
//         ) : type === 'textarea' ? (
//             <textarea id={name} name={name} value={value} onChange={onChange} rows={4} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm" placeholder={placeholder}></textarea>
//         ) : (
//             <input type={type} id={name} name={name} value={value} onChange={onChange} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm" placeholder={placeholder} />
//         )}
//     </div>
// );


// const ProfilePage: React.FC = () => {
//     const auth = useContext(AuthContext);
//     const toast = useToast();
//     const [user, setUser] = useState<User | null>(auth?.currentUser || null);
//     const [editedUser, setEditedUser] = useState<User | null>(JSON.parse(JSON.stringify(auth?.currentUser || null)));
//     const [isEditing, setIsEditing] = useState(false);
    
//     const [newSkill, setNewSkill] = useState('');
//     const [newExperienceSkills, setNewExperienceSkills] = useState<string[]>(editedUser?.experience?.map(() => '') || []);

//     const [bannerUrl, setBannerUrl] = useState<string>("https://images.unsplash.com/photo-1550439062-609e1531270e?auto=format&fit=crop&q=80&w=1920");
//     const [bannerPreview, setBannerPreview] = useState<string | null>(null);
//     const [avatarPreview, setAvatarPreview] = useState<string | null>(null);
//     const bannerInputRef = useRef<HTMLInputElement>(null);
//     const avatarInputRef = useRef<HTMLInputElement>(null);
    
//     const handleImageChange = (
//       e: React.ChangeEvent<HTMLInputElement>, 
//       setter: React.Dispatch<React.SetStateAction<string | null>>
//     ) => {
//       if (e.target.files && e.target.files[0]) {
//         const file = e.target.files[0];
//         setter(URL.createObjectURL(file));
//       }
//     };
    
//     const handleRemoveImage = (setter: React.Dispatch<React.SetStateAction<string | null>>) => {
//         setter('REMOVED');
//     };

//     const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
//         if (editedUser) {
//             setEditedUser({ ...editedUser, [e.target.name]: e.target.value });
//         }
//     };

//     const handleListChange = (listName: 'experience' | 'education', index: number, event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
//         if (!editedUser) return;
//         const { name, value } = event.target;
//         const list = editedUser[listName] ? [...editedUser[listName]!] : [];
//         if (list[index]) {
//             const item = { ...list[index], [name]: value };
//             list[index] = item;
//             setEditedUser({ ...editedUser, [listName]: list });
//         }
//     };

//     const addListItem = (listName: 'experience' | 'education') => {
//         if (!editedUser) return;
//         const list = editedUser[listName] ? [...editedUser[listName]!] : [];
//         const newItem = listName === 'experience' 
//             ? { title: '', company: '', duration: '', description: '', skills: [] }
//             : { school: '', degree: '', fieldOfStudy: '', duration: '' };
//         setEditedUser({ ...editedUser, [listName]: [...list, newItem] });
//         if (listName === 'experience') {
//             setNewExperienceSkills(prev => [...prev, '']);
//         }
//     };

//     const removeListItem = (listName: 'experience' | 'education', index: number) => {
//         if (!editedUser) return;
//         const list = editedUser[listName] ? [...editedUser[listName]!] : [];
//         list.splice(index, 1);
//         setEditedUser({ ...editedUser, [listName]: list });
//          if (listName === 'experience') {
//             setNewExperienceSkills(prev => prev.filter((_, i) => i !== index));
//         }
//     };
    
//     // --- Main Skills Handlers ---
//     const handleAddSkill = () => {
//         if (newSkill.trim() && editedUser && !editedUser.skills?.includes(newSkill.trim())) {
//             const skills = editedUser.skills ? [...editedUser.skills, newSkill.trim()] : [newSkill.trim()];
//             setEditedUser({ ...editedUser, skills });
//             setNewSkill('');
//         }
//     };

//     const handleRemoveSkill = (skillToRemove: string) => {
//         if (editedUser) {
//             setEditedUser({ ...editedUser, skills: editedUser.skills?.filter(s => s !== skillToRemove) });
//         }
//     };
    
//     // --- Experience-Specific Skills Handlers ---
//      const handleNewExperienceSkillChange = (index: number, value: string) => {
//         setNewExperienceSkills(prev => {
//             const newSkills = [...prev];
//             newSkills[index] = value;
//             return newSkills;
//         });
//     };
    
//     const handleAddExperienceSkill = (expIndex: number) => {
//         if (!editedUser || !editedUser.experience) return;
//         const skillToAdd = newExperienceSkills[expIndex]?.trim();
//         if (!skillToAdd) return;

//         const updatedExperience = [...editedUser.experience];
//         const currentSkills = updatedExperience[expIndex].skills || [];
        
//         if (!currentSkills.includes(skillToAdd)) {
//             updatedExperience[expIndex].skills = [...currentSkills, skillToAdd];
//             setEditedUser({ ...editedUser, experience: updatedExperience });
//             handleNewExperienceSkillChange(expIndex, '');
//         }
//     };
    
//     const handleRemoveExperienceSkill = (expIndex: number, skillToRemove: string) => {
//          if (!editedUser || !editedUser.experience) return;
//          const updatedExperience = [...editedUser.experience];
//          updatedExperience[expIndex].skills = (updatedExperience[expIndex].skills || []).filter(s => s !== skillToRemove);
//          setEditedUser({ ...editedUser, experience: updatedExperience });
//     };

//     const handleSaveChanges = (e: React.FormEvent) => {
//         e.preventDefault();
//         if (editedUser) {
//             const finalUser = { ...editedUser };
//             if (avatarPreview) {
//                 finalUser.avatar = avatarPreview === 'REMOVED' ? DEFAULT_AVATAR_URL : avatarPreview;
//             }
//             setUser(finalUser);
//         }
//         if (bannerPreview) {
//             setBannerUrl(bannerPreview === 'REMOVED' ? DEFAULT_BANNER_URL : bannerPreview);
//         }
//         setIsEditing(false);
//         setBannerPreview(null);
//         setAvatarPreview(null);
//         toast.success("Profile updated successfully!");
//     };

//     const handleCancel = () => {
//         setEditedUser(JSON.parse(JSON.stringify(user)));
//         setIsEditing(false);
//         setBannerPreview(null);
//         setAvatarPreview(null);
//     };

//     if (!user || !editedUser) return <div>Loading...</div>;

//     if (isEditing) {
//         return (
//             <form onSubmit={handleSaveChanges} className="space-y-6">
//                 <PageTitle title="Edit Profile" />
                
//                 <Card className="p-0 overflow-visible">
//                      <div className="h-48 bg-gray-300 relative group">
//                         <img src={bannerPreview === 'REMOVED' ? DEFAULT_BANNER_URL : (bannerPreview || bannerUrl)} alt="Banner" className="w-full h-full object-cover rounded-t-2xl" />
//                         <div className="absolute inset-0 bg-black/50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity rounded-t-2xl">
//                             <div className="flex gap-4">
//                                 <button type="button" onClick={() => bannerInputRef.current?.click()} className="flex flex-col items-center text-white hover:text-primary-200">
//                                     <UploadIcon className="h-8 w-8 text-white"/>
//                                     <span className="text-sm font-semibold">Upload</span>
//                                 </button>
//                                 <button type="button" onClick={() => handleRemoveImage(setBannerPreview)} className="flex flex-col items-center text-white hover:text-red-300">
//                                     <TrashIcon />
//                                     <span className="text-sm font-semibold">Remove</span>
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                     <input type="file" accept="image/*" ref={bannerInputRef} onChange={(e) => handleImageChange(e, setBannerPreview)} className="hidden" />
//                      <div className="p-6 relative">
//                         <div className="absolute -top-20 left-6">
//                             <div className="w-40 h-40 rounded-full border-4 border-white bg-white relative group">
//                                  <img src={avatarPreview === 'REMOVED' ? DEFAULT_AVATAR_URL : (avatarPreview || editedUser.avatar)} alt="User Avatar" className="w-full h-full rounded-full object-cover" />
//                                  <div className="absolute inset-0 bg-black/50 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
//                                     <div className="flex gap-4">
//                                         <button type="button" onClick={() => avatarInputRef.current?.click()} className="flex flex-col items-center text-white text-sm hover:text-primary-200">
//                                             <PencilIcon className="h-5 w-5"/>
//                                             <span>Edit</span>
//                                         </button>
//                                         <button type="button" onClick={() => handleRemoveImage(setAvatarPreview)} className="flex flex-col items-center text-white text-sm hover:text-red-300">
//                                             <TrashIcon/>
//                                             <span>Remove</span>
//                                         </button>
//                                     </div>
//                                  </div>
//                             </div>
//                             <input type="file" accept="image/*" ref={avatarInputRef} onChange={(e) => handleImageChange(e, setAvatarPreview)} className="hidden" />
//                         </div>
//                         <div className="ml-44 pt-4 space-y-4">
//                             <EditableItem label="First Name" name="firstName" value={editedUser.firstName} onChange={handleInputChange} placeholder="Your first name" />
//                             <EditableItem label="Last Name" name="lastName" value={editedUser.lastName} onChange={handleInputChange} placeholder="Your last name" />
//                             <EditableItem label="description" name="description" value={editedUser.description || ''} onChange={handleInputChange} placeholder="e.g., Full-stack Developer" />
//                             <EditableItem label="Location" name="location" value={editedUser.location || ''} onChange={handleInputChange} placeholder="e.g., Chennai, India" />
//                         </div>
//                      </div>
//                 </Card>

//                 <Card className="p-6">
//                     <h3 className="text-lg font-bold text-gray-800 mb-2">About</h3>
//                     <EditableItem label="" name="bio" value={editedUser.bio} onChange={handleInputChange} type="textarea" placeholder="Tell us about yourself..." />
//                 </Card>

//                 <Card className="p-6">
//                     <h3 className="text-lg font-bold text-gray-800 mb-4">Experience</h3>
//                     <div className="space-y-6">
//                     {(editedUser.experience || []).map((exp, index) => (
//                         <div key={index} className="p-4 border rounded-lg space-y-4 relative bg-gray-50/50">
//                             <button type="button" onClick={() => removeListItem('experience', index)} className="absolute top-2 right-2 text-red-400 hover:text-red-600 p-1 rounded-full hover:bg-red-50"><TrashIcon /></button>
//                             <EditableItem label="Title" name="title" value={exp.title} onChange={(e) => handleListChange('experience', index, e)} placeholder="e.g., Software Engineer" />
//                             <EditableItem label="Company" name="company" value={exp.company} onChange={(e) => handleListChange('experience', index, e)} placeholder="e.g., Google" />
//                             <EditableItem label="Duration" name="duration" value={exp.duration} onChange={(e) => handleListChange('experience', index, e)} placeholder="e.g., Jan 2022 - Present" />
//                             <EditableItem label="Description" name="description" value={exp.description} onChange={(e) => handleListChange('experience', index, e)} type="textarea" placeholder="Your responsibilities and achievements..." />
//                             <div>
//                                 <label className="block text-sm font-medium text-gray-700 mb-2">Related Skills</label>
//                                 <div className="flex flex-wrap gap-2 mb-2">
//                                     {(exp.skills || []).map(skill => (
//                                         <span key={skill} className="flex items-center gap-2 bg-gray-200 text-gray-800 px-2.5 py-1 rounded-full text-xs font-medium">
//                                             {skill}
//                                             <button type="button" onClick={() => handleRemoveExperienceSkill(index, skill)} className="text-gray-500 hover:text-gray-700"><XCircleIcon/></button>
//                                         </span>
//                                     ))}
//                                 </div>
//                                 <div className="flex gap-2">
//                                     <input type="text" value={newExperienceSkills[index]} onChange={e => handleNewExperienceSkillChange(index, e.target.value)} placeholder="Add a related skill" className="flex-grow p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary text-sm" />
//                                     <Button type="button" variant="secondary" size="sm" onClick={() => handleAddExperienceSkill(index)}>Add</Button>
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                     </div>
//                     <Button type="button" variant="outline" size="sm" onClick={() => addListItem('experience')} className="mt-4"><PlusIcon/>Add Experience</Button>
//                 </Card>

//                 <Card className="p-6">
//                     <h3 className="text-lg font-bold text-gray-800 mb-4">Education</h3>
//                      <div className="space-y-6">
//                     {(editedUser.education || []).map((edu, index) => (
//                         <div key={index} className="p-4 border rounded-lg space-y-3 relative bg-gray-50/50">
//                             <button type="button" onClick={() => removeListItem('education', index)} className="absolute top-2 right-2 text-red-400 hover:text-red-600 p-1 rounded-full hover:bg-red-50"><TrashIcon /></button>
//                             <EditableItem label="School" name="school" value={edu.school} onChange={(e) => handleListChange('education', index, e)} placeholder="e.g., Stanford University" />
//                             <EditableItem label="Degree" name="degree" value={edu.degree} onChange={(e) => handleListChange('education', index, e)} placeholder="e.g., Bachelor of Science" />
//                             <EditableItem label="Field of Study" name="fieldOfStudy" value={edu.fieldOfStudy} onChange={(e) => handleListChange('education', index, e)} placeholder="e.g., Computer Science" />
//                             <EditableItem label="Duration" name="duration" value={edu.duration} onChange={(e) => handleListChange('education', index, e)} placeholder="e.g., 2018 - 2022" />
//                         </div>
//                     ))}
//                     </div>
//                     <Button type="button" variant="outline" size="sm" onClick={() => addListItem('education')} className="mt-4"><PlusIcon/>Add Education</Button>
//                 </Card>

//                 <Card className="p-6">
//                     <h3 className="text-lg font-bold text-gray-800 mb-4">Skills</h3>
//                     <div className="flex flex-wrap gap-2 mb-4">
//                         {(editedUser.skills || []).map(skill => (
//                             <span key={skill} className="flex items-center gap-2 bg-gray-100 text-gray-700 px-3 py-1.5 rounded-full text-sm font-medium">
//                                 {skill}
//                                 <button type="button" onClick={() => handleRemoveSkill(skill)} className="text-gray-400 hover:text-gray-600"><XCircleIcon/></button>
//                             </span>
//                         ))}
//                     </div>
//                     <div className="flex gap-2">
//                         <input type="text" value={newSkill} onChange={e => setNewSkill(e.target.value)} placeholder="Add a new skill" className="flex-grow p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary" />
//                         <Button type="button" variant="secondary" onClick={handleAddSkill}>Add</Button>
//                     </div>
//                 </Card>
                
//                 <div className="p-4 flex justify-end gap-2">
//                     <Button type="button" variant="secondary" onClick={handleCancel}>Cancel</Button>
//                     <Button type="submit">Save Changes</Button>
//                 </div>

//             </form>
//         );
//     }

//     return (
//         <div>
//             <PageTitle title="My Profile" subtitle="Manage your personal information and settings.">
//                 <Button onClick={() => setIsEditing(true)}>
//                     <EditIcon />
//                     Edit Profile
//                 </Button>
//             </PageTitle>

//             <div className="space-y-6 mt-6">
//                 <Card className="overflow-hidden p-0 relative">
//                     <div className="h-48 bg-gray-300">
//                         <img src={bannerUrl} alt="Banner" className="w-full h-full object-cover" />
//                     </div>
//                     <div className="p-6 relative">
//                         <img src={user.avatar || DEFAULT_AVATAR_URL} alt="User Avatar" className="w-40 h-40 rounded-full border-4 border-white absolute -top-20 bg-white object-cover" />
//                         <div className="ml-44 pt-4">
//                             <h1 className="text-3xl font-bold text-gray-900">{user.firstName} {user.lastName}</h1>
//                             {user.description && <p className="text-gray-700 mt-1">{user.description}</p>}
//                             {user.location && <p className="text-sm text-gray-500 mt-2">{user.location}</p>}
//                              <p className="text-sm text-gray-500 mt-2">{user.email}</p>
//                             <span className={`inline-flex items-center px-3 py-0.5 mt-2 rounded-full text-xs font-semibold capitalize ${user.mode === 'online' ? 'bg-blue-100 text-blue-800' : 'bg-gray-200 text-gray-800'}`}>
//                                 {user.mode} Student
//                             </span>
//                         </div>
//                     </div>
//                 </Card>
        
//                 <Card className="p-6">
//                     <h2 className="text-xl font-bold text-gray-800 mb-2">About</h2>
//                     <p className="text-gray-700 leading-relaxed whitespace-pre-wrap">{user.bio}</p>
//                 </Card>
                
//                 {user.experience && user.experience.length > 0 && (
//                     <Card className="p-6">
//                         <h2 className="text-xl font-bold text-gray-800 mb-4">Experience</h2>
//                         <div className="space-y-6">
//                             {user.experience.map((exp, index) => (
//                                 <div key={index} className="flex gap-4">
//                                     <div className="w-12 h-12 bg-gray-100 rounded-md flex items-center justify-center flex-shrink-0"><CompanyIcon /></div>
//                                     <div>
//                                         <h3 className="font-bold text-lg text-gray-900">{exp.title}</h3>
//                                         <p className="text-sm font-medium text-gray-800">{exp.company}</p>
//                                         <p className="text-xs text-gray-500">{exp.duration}</p>
//                                         <p className="text-sm mt-2 text-gray-700 whitespace-pre-wrap">{exp.description}</p>
//                                         {exp.skills && exp.skills.length > 0 && (
//                                             <div className="mt-3">
//                                                 <h4 className="text-xs font-semibold text-gray-600">Skills:</h4>
//                                                 <div className="flex flex-wrap gap-1.5 mt-1">
//                                                     {exp.skills.map(skill => (
//                                                          <span key={skill} className="bg-gray-100 text-gray-700 px-2 py-1 rounded-md text-xs font-medium">
//                                                             {skill}
//                                                         </span>
//                                                     ))}
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </Card>
//                 )}

//                 {user.education && user.education.length > 0 && (
//                      <Card className="p-6">
//                         <h2 className="text-xl font-bold text-gray-800 mb-4">Education</h2>
//                         <div className="space-y-6">
//                             {user.education.map((edu, index) => (
//                                 <div key={index} className="flex gap-4">
//                                     <div className="w-12 h-12 bg-gray-100 rounded-md flex items-center justify-center flex-shrink-0"><EducationIcon /></div>
//                                     <div>
//                                         <h3 className="font-bold text-lg text-gray-900">{edu.school}</h3>
//                                         <p className="text-sm font-medium text-gray-800">{edu.degree}, {edu.fieldOfStudy}</p>
//                                         <p className="text-xs text-gray-500">{edu.duration}</p>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </Card>
//                 )}
        
//                 {user.skills && user.skills.length > 0 && (
//                     <Card className="p-6">
//                         <h2 className="text-xl font-bold text-gray-800 mb-4">Skills</h2>
//                         <div className="flex flex-wrap gap-2">
//                             {user.skills.map(skill => (
//                                 <span key={skill} className="bg-gray-100 text-gray-700 px-3 py-1.5 rounded-full text-sm font-medium">
//                                     {skill}
//                                 </span>
//                             ))}
//                         </div>
//                     </Card>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default ProfilePage;


import React, { useContext, useState, useRef, useEffect } from 'react';
import { PageTitle, Button, Card } from '../components/common';
import { AuthContext } from '../contexts/AuthContext';
import { User, Experience, Education } from '../types';
import { useToast } from '../components/Toaster';
import { getTraineeProfile, updateTraineeDetails, uploadProfileImages } from '../services/api';
import { getImageUrl } from '../services/imagePathConfig';

const API_HOST = "http://localhost:4002";
const DEFAULT_BANNER_URL = "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&w=1920&q=80";
const DEFAULT_AVATAR_URL = "https://static.vecteezy.com/system/resources/thumbnails/009/292/244/small/default-avatar-icon-of-social-media-user-vector.jpg";

const EditIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.5L15.232 5.232z" /></svg>;
const UploadIcon: React.FC<{className?: string}> = ({className = "h-10 w-10 text-gray-400"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" /></svg>;
const TrashIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>;
const PencilIcon: React.FC<{ className?: string }> = ({ className = "h-5 w-5" }) => <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.5L15.232 5.232z" /></svg>;
const CompanyIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-gray-500" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" /></svg>;
const EducationIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-gray-500" viewBox="0 0 20 20" fill="currentColor"><path d="M10.394 2.08a1 1 0 00-.788 0l-7 3.5a1 1 0 00.788 1.84L10 9.75l6.606-2.25a1 1 0 00.788-1.84l-7-3.5zM3 9.25L10 12l7-2.75v4.5a1 1 0 11-2 0v-2.5L10 12.25 5 10.25v2.5a1 1 0 11-2 0v-4.5z" /><path fillRule="evenodd" d="M10 12.5a1 1 0 00-1 1v3.5a1 1 0 001 1h.5a1 1 0 001-1v-3.5a1 1 0 00-1-1h-.5z" clipRule="evenodd" /></svg>;
const PlusIcon = () => <svg className="w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" /></svg>;
const XCircleIcon = () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;

const EditableItem: React.FC<{ label: string; name: string; value: string; onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void; type?: string; options?: string[]; placeholder?: string; }> = 
({ label, name, value, onChange, type = 'text', options, placeholder }) => (
    <div>
        <label htmlFor={name} className="block text-sm font-medium text-gray-700">{label}</label>
        {type === 'select' ? (
             <select id={name} name={name} value={value} onChange={onChange} className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm rounded-md">
                {options?.map(opt => <option key={opt}>{opt}</option>)}
            </select>
        ) : type === 'textarea' ? (
            <textarea id={name} name={name} value={value} onChange={onChange} rows={4} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm" placeholder={placeholder}></textarea>
        ) : (
            <input type={type} id={name} name={name} value={value} onChange={onChange} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm" placeholder={placeholder} />
        )}
    </div>
);

const ProfilePage: React.FC = () => {
    const auth = useContext(AuthContext);
    const toast = useToast();
    const [user, setUser] = useState<User | null>(auth?.currentUser || null);
    const [editedUser, setEditedUser] = useState<User | null>(auth?.currentUser || null);
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(true);
    
    const [newSkill, setNewSkill] = useState('');
    const [newExperienceSkills, setNewExperienceSkills] = useState<string[]>([]);

    const [bannerUrl, setBannerUrl] = useState<string>(DEFAULT_BANNER_URL);
    const [bannerFile, setBannerFile] = useState<File | null>(null);
    const [avatarFile, setAvatarFile] = useState<File | null>(null);
    const bannerInputRef = useRef<HTMLInputElement>(null);
    const avatarInputRef = useRef<HTMLInputElement>(null);
    
    // Fetch profile data from API when component mounts
    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                setIsFetching(true);
                const traineeToken = localStorage.getItem('TraineeToken');
                console.log('Fetching profile with token:', traineeToken);
                
                if (!traineeToken) {
                    console.log('No TraineeToken found in localStorage');
                    setIsFetching(false);
                    return;
                }
                
                const response = await getTraineeProfile(traineeToken);
                console.log('Profile API response:', response);
                
                if (response.success && response.data) {
                    const profileData = response.data;
                    
                    // Transform API data to match frontend User structure
                    const transformedUser: User = {
                        ...auth?.currentUser!,
                        id: auth?.currentUser?.id || '',
                        firstName: profileData.basicInfo?.fullName?.split(' ')[0] || auth?.currentUser?.firstName || '',
                        lastName: profileData.basicInfo?.fullName?.split(' ').slice(1).join(' ') || auth?.currentUser?.lastName || '',
                        description: profileData.profileDetail?.description || '', // Map description to description
                        location: profileData.profileDetail?.location || '',
                        linkedin: profileData.profileDetail?.linkedin || '',
                        bio: profileData.profileDetail?.about || '',
                        skills: (() => {
                            const skillsData = profileData.profileDetail?.skills;
                            if (!skillsData) return [];
                            if (Array.isArray(skillsData)) return skillsData;
                            if (typeof skillsData === 'string') {
                                try {
                                    const parsed = JSON.parse(skillsData);
                                    return Array.isArray(parsed) ? parsed : [];
                                } catch {
                                    // Handle cases where it might be a comma-separated string instead of JSON
                                    return skillsData.split(',').map(s => s.trim()).filter(Boolean);
                                }
                            }
                            return [];
                        })(),
                        experience: (profileData.experiences || [])
                            .map((exp: any) => ({
                                id: exp.id?.toString() || '',
                                title: exp.title || '',
                                company: exp.company || '',
                                duration: exp.duration || '',
                                description: exp.description || '',
                                skills: (() => {
                                    const relSkills = exp.relatedSkills;
                                    if (!relSkills) return [];
                                    if (Array.isArray(relSkills)) return relSkills;
                                    if (typeof relSkills === 'string') {
                                        try {
                                            const parsed = JSON.parse(relSkills);
                                            return Array.isArray(parsed) ? parsed : [];
                                        } catch {
                                            return relSkills.split(',').map(s => s.trim()).filter(Boolean);
                                        }
                                    }
                                    return [];
                                })()
                            }))
                            .sort((a: any, b: any) => {
                                const parseYear = (dur: string) => {
                                    if (!dur) return 0;
                                    if (dur.toLowerCase().includes('present')) return 9999;
                                    const years = dur.match(/\d{4}/g);
                                    return years ? Math.max(...years.map(Number)) : 0;
                                };
                                return parseYear(b.duration) - parseYear(a.duration);
                            }) || [],
                        education: (profileData.education || [])
                            .map((edu: any) => ({
                                id: edu.id?.toString() || '',
                                school: edu.school || '',
                                degree: edu.degree || '',
                                fieldOfStudy: edu.fieldOfStudy || '',
                                duration: edu.duration || ''
                            }))
                            .sort((a: any, b: any) => {
                                const getPriority = (item: any) => {
                                    const deg = (item.degree || "").toUpperCase();
                                    if (deg.includes("SSLC") || deg.includes("10TH")) return 3;
                                    if (deg.includes("HSC") || deg.includes("12TH")) return 2;
                                    return 1;
                                };
                                return getPriority(a) - getPriority(b);
                            }),
                        projects: (() => {
                        const projectsData = profileData.profileDetail?.projects;
                        if (!projectsData) return [];
                        if (Array.isArray(projectsData)) {
                            return projectsData.map((proj: any) => ({
                                id: proj.id?.toString() || '',
                                projectName: proj.projectName || '',
                                projectDescription: proj.projectDescription || '',
                                githubLink: proj.githubLink || ''
                            }));
                        }
                        if (typeof projectsData === 'string') {
                            try {
                                const parsed = JSON.parse(projectsData);
                                return Array.isArray(parsed) ? parsed.map((proj: any) => ({
                                    id: proj.id?.toString() || '',
                                    projectName: proj.projectName || '',
                                    projectDescription: proj.projectDescription || '',
                                    githubLink: proj.githubLink || ''
                                })) : [];
                            } catch {
                                return [];
                            }
                        }
                        return [];
                    })()
                    };
                    
                    setUser(transformedUser);
                    setEditedUser(transformedUser);
                    setNewExperienceSkills(transformedUser.experience?.map(() => '') || []);
                    
                    // Load saved images from API
                    if (profileData.profileDetail?.profilePicture) {
                        transformedUser.avatar = getImageUrl(profileData.profileDetail.profilePicture) || DEFAULT_AVATAR_URL;
                    }
                    if (profileData.profileDetail?.bannerImage) {
                        setBannerUrl(getImageUrl(profileData.profileDetail.bannerImage) || DEFAULT_BANNER_URL);
                    }
                    setUser(transformedUser);
                    setEditedUser(transformedUser);
                    console.log('Profile loaded successfully');
                } else {
                    toast.error(response.message || "Failed to load profile");
                }
            } catch (error) {
                console.error('Error fetching profile:', error);
                toast.error("Failed to load profile data");
            } finally {
                setIsFetching(false);
            }
        };

        fetchProfileData();
    }, []); // Empty dependency array to run only once
    
    const handleImageChange = (
      e: React.ChangeEvent<HTMLInputElement>,
      type: 'profile' | 'banner'
    ) => {
      if (e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (type === 'profile') {
          setAvatarFile(file);
          if (editedUser) {
            setEditedUser({ ...editedUser, avatar: URL.createObjectURL(file) });
          }
        } else {
          setBannerFile(file);
          setBannerUrl(URL.createObjectURL(file));
        }
      }
    };
    
    const handleRemoveImage = (type: 'profile' | 'banner') => {
      if (type === 'profile') {
        setAvatarFile(null);
        if (editedUser) {
          setEditedUser({ ...editedUser, avatar: DEFAULT_AVATAR_URL });
        }
      } else {
        setBannerFile(null);
        setBannerUrl(DEFAULT_BANNER_URL);
      }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        if (editedUser) {
            setEditedUser({ ...editedUser, [e.target.name]: e.target.value });
        }
    };

    const handleListChange = (listName: 'experience' | 'education' | 'projects', index: number, event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        if (!editedUser) return;
        const { name, value } = event.target;
        const list = editedUser[listName] ? [...editedUser[listName]!] : [];
        if (list[index]) {
            const item = { ...list[index], [name]: value };
            list[index] = item;
            setEditedUser({ ...editedUser, [listName]: list });
        }
    };

    const addListItem = (listName: 'experience' | 'education' | 'projects') => {
        if (!editedUser) return;
        const list = editedUser[listName] ? [...editedUser[listName]!] : [];
        let newItem: any;
        if (listName === 'experience') {
            newItem = { id: '', title: '', company: '', duration: '', description: '', skills: [] };
        } else if (listName === 'education') {
            newItem = { id: '', school: '', degree: '', fieldOfStudy: '', duration: '' };
        } else {
            newItem = { id: '', projectName: '', projectDescription: '', githubLink: '' };
        }
        setEditedUser({ ...editedUser, [listName]: [...list, newItem] });
        if (listName === 'experience') {
            setNewExperienceSkills(prev => [...prev, '']);
        }
    };

    const removeListItem = (listName: 'experience' | 'education' | 'projects', index: number) => {
        if (!editedUser) return;
        const list = editedUser[listName] ? [...editedUser[listName]!] : [];
        list.splice(index, 1);
        setEditedUser({ ...editedUser, [listName]: list });
         if (listName === 'experience') {
            setNewExperienceSkills(prev => prev.filter((_, i) => i !== index));
        }
    };
    
    // --- Main Skills Handlers ---
    const handleAddSkill = () => {
        if (newSkill.trim() && editedUser && !editedUser.skills?.includes(newSkill.trim())) {
            const skills = editedUser.skills ? [...editedUser.skills, newSkill.trim()] : [newSkill.trim()];
            setEditedUser({ ...editedUser, skills });
            setNewSkill('');
        }
    };

    const handleRemoveSkill = (skillToRemove: string) => {
        if (editedUser) {
            setEditedUser({ ...editedUser, skills: editedUser.skills?.filter(s => s !== skillToRemove) });
        }
    };
    
    // --- Experience-Specific Skills Handlers ---
     const handleNewExperienceSkillChange = (index: number, value: string) => {
        setNewExperienceSkills(prev => {
            const newSkills = [...prev];
            newSkills[index] = value;
            return newSkills;
        });
    };
    
    const handleAddExperienceSkill = (expIndex: number) => {
        if (!editedUser || !editedUser.experience) return;
        const skillToAdd = newExperienceSkills[expIndex]?.trim();
        if (!skillToAdd) return;

        const updatedExperience = [...editedUser.experience];
        const currentSkills = updatedExperience[expIndex].skills || [];
        
        if (!currentSkills.includes(skillToAdd)) {
            updatedExperience[expIndex].skills = [...currentSkills, skillToAdd];
            setEditedUser({ ...editedUser, experience: updatedExperience });
            handleNewExperienceSkillChange(expIndex, '');
        }
    };
    
    const handleRemoveExperienceSkill = (expIndex: number, skillToRemove: string) => {
         if (!editedUser || !editedUser.experience) return;
         const updatedExperience = [...editedUser.experience];
         updatedExperience[expIndex].skills = (updatedExperience[expIndex].skills || []).filter(s => s !== skillToRemove);
         setEditedUser({ ...editedUser, experience: updatedExperience });
    };

    const handleSaveChanges = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!editedUser) return;
        
        try {
            setIsLoading(true);
            const traineeToken = localStorage.getItem('TraineeToken');
            console.log('Updating profile with token:', traineeToken);
            
            if (!traineeToken) {
                toast.error("Authentication token not found");
                return;
            }

            // Prepare data for API - CORRECTED PAYLOAD FORMAT
            const profileData = {
                TraineeToken: traineeToken,
                fullName: `${editedUser.firstName} ${editedUser.lastName}`.trim(),
                description: editedUser.description || '',
                location: editedUser.location || '',
                linkedin: editedUser.linkedin || '',
                about: editedUser.bio || '',
                skills: editedUser.skills || [],
                experiences: editedUser.experience?.map(exp => ({
                    id: exp.id || undefined,
                    title: exp.title,
                    company: exp.company,
                    duration: exp.duration,
                    description: exp.description,
                    relatedSkills: exp.skills || []
                })) || [],
                education: editedUser.education?.map(edu => ({
                    id: edu.id || undefined,
                    school: edu.school,
                    degree: edu.degree,
                    fieldOfStudy: edu.fieldOfStudy,
                    duration: edu.duration
                })) || [],
                projects: editedUser.projects?.map(proj => ({
                    id: proj.id || undefined,
                    projectName: proj.projectName,
                    projectDescription: proj.projectDescription,
                    githubLink: proj.githubLink
                })) || []
            };

            console.log('Sending profile data:', profileData);
            const response = await updateTraineeDetails(profileData);
            console.log('Update response:', response);
            
            if (response.success) {
                const updatedProfile = response.data;
                const transformedUser: User = {
                    ...editedUser,
                    id: editedUser.id,
                    firstName: updatedProfile.trainee?.fullName?.split(' ')[0] || editedUser.firstName,
                    lastName: updatedProfile.trainee?.fullName?.split(' ').slice(1).join(' ') || editedUser.lastName,
                    description: updatedProfile.traineeDetail?.description || '',
                    location: updatedProfile.traineeDetail?.location || '',
                    linkedin: updatedProfile.traineeDetail?.linkedin || '',
                    bio: updatedProfile.traineeDetail?.about || '',
                    skills: (() => {
                        const skillsData = updatedProfile.traineeDetail?.skills;
                        if (!skillsData) return [];
                        if (Array.isArray(skillsData)) return skillsData;
                        if (typeof skillsData === 'string') {
                            try {
                                const parsed = JSON.parse(skillsData);
                                return Array.isArray(parsed) ? parsed : [];
                            } catch {
                                return skillsData.split(',').map(s => s.trim()).filter(Boolean);
                            }
                        }
                        return [];
                    })(),
                    experience: (updatedProfile.experiences && updatedProfile.experiences.length > 0)
                        ? updatedProfile.experiences
                            .map((exp: any) => ({
                                id: exp.id?.toString() || '',
                                title: exp.title || '',
                                company: exp.company || '',
                                duration: exp.duration || '',
                                description: exp.description || '',
                                skills: (() => {
                                    const relSkills = exp.relatedSkills;
                                    if (!relSkills) return [];
                                    if (Array.isArray(relSkills)) return relSkills;
                                    if (typeof relSkills === 'string') {
                                        try {
                                            const parsed = JSON.parse(relSkills);
                                            return Array.isArray(parsed) ? parsed : [];
                                        } catch {
                                            return relSkills.split(',').map(s => s.trim()).filter(Boolean);
                                        }
                                    }
                                    return [];
                                })()
                            }))
                            .sort((a: any, b: any) => {
                                const parseYear = (dur: string) => {
                                    if (!dur) return 0;
                                    if (dur.toLowerCase().includes('present')) return 9999;
                                    const years = dur.match(/\d{4}/g);
                                    return years ? Math.max(...years.map(Number)) : 0;
                                };
                                return parseYear(b.duration) - parseYear(a.duration);
                            })
                        : editedUser.experience || [],
                    education: (updatedProfile.education && updatedProfile.education.length > 0)
                        ? updatedProfile.education
                            .map((edu: any) => ({
                                id: edu.id?.toString() || '',
                                school: edu.school || '',
                                degree: edu.degree || '',
                                fieldOfStudy: edu.fieldOfStudy || '',
                                duration: edu.duration || ''
                            }))
                            .sort((a: any, b: any) => {
                                const getPriority = (item: any) => {
                                    const deg = (item.degree || "").toUpperCase();
                                    if (deg.includes("SSLC") || deg.includes("10TH")) return 3;
                                    if (deg.includes("HSC") || deg.includes("12TH")) return 2;
                                    return 1;
                                };
                                return getPriority(a) - getPriority(b);
                            })
                        : editedUser.education || [],
                    projects: (() => {
                        const projectsData = updatedProfile.traineeDetail?.projects;
                        if (!projectsData) return editedUser.projects || [];
                        if (Array.isArray(projectsData)) {
                            return projectsData.map((proj: any) => ({
                                id: proj.id?.toString() || '',
                                projectName: proj.projectName || '',
                                projectDescription: proj.projectDescription || '',
                                githubLink: proj.githubLink || ''
                            }));
                        }
                        if (typeof projectsData === 'string') {
                            try {
                                const parsed = JSON.parse(projectsData);
                                return Array.isArray(parsed) ? parsed.map((proj: any) => ({
                                    id: proj.id?.toString() || '',
                                    projectName: proj.projectName || '',
                                    projectDescription: proj.projectDescription || '',
                                    githubLink: proj.githubLink || ''
                                })) : [];
                            } catch {
                                return editedUser.projects || [];
                            }
                        }
                        return editedUser.projects || [];
                    })()
                };

                // Upload images if any
                if (avatarFile || bannerFile) {
                    const formData = new FormData();
                    formData.append('TraineeToken', traineeToken);
                    if (avatarFile) formData.append('profilePicture', avatarFile);
                    if (bannerFile) formData.append('bannerImage', bannerFile);
                    
                    try {
                        const uploadResponse = await uploadProfileImages(formData);
                        if (uploadResponse.success && uploadResponse.data) {
                            if (uploadResponse.data.profilePicture) {
                                transformedUser.avatar = getImageUrl(uploadResponse.data.profilePicture) || DEFAULT_AVATAR_URL;
                            }
                            if (uploadResponse.data.bannerImage) {
                                setBannerUrl(getImageUrl(uploadResponse.data.bannerImage) || DEFAULT_BANNER_URL);
                            }
                        }
                    } catch (uploadError) {
                        console.error('Image upload failed:', uploadError);
                        toast.error("Profile updated but image upload failed");
                    }
                }

                setUser(transformedUser);
                setEditedUser(transformedUser);
                setIsEditing(false);
                setAvatarFile(null);
                setBannerFile(null);
                setNewExperienceSkills(transformedUser.experience?.map(() => '') || []);
                toast.success("Profile updated successfully!");
            } else {
                toast.error(response.message || "Failed to update profile");
            }
        } catch (error) {
            console.error('Error updating profile:', error);
            toast.error("Failed to update profile");
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancel = () => {
        setEditedUser(user);
        setIsEditing(false);
        setAvatarFile(null);
        setBannerFile(null);
        if (user) {
            setBannerUrl(user.avatar || DEFAULT_BANNER_URL);
        }
        setNewExperienceSkills(user?.experience?.map(() => '') || []);
    };

    if (isFetching) {
        return (
            <div className="flex justify-center items-center min-h-64">
                <div className="text-lg">Loading profile...</div>
            </div>
        );
    }

    if (!user || !editedUser) return <div>No user data found</div>;

    if (isEditing) {
        return (
            <form onSubmit={handleSaveChanges} className="space-y-6">
                <PageTitle title="Edit Profile" />
                
                <Card className="p-0 overflow-visible">
                     <div className="h-48 bg-gray-300 relative group">
                        <img src={bannerUrl} alt="Banner" className="w-full h-full object-cover rounded-t-2xl" />
                        <div className="absolute inset-0 bg-black/50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity rounded-t-2xl">
                            <div className="flex gap-4">
                                <button type="button" onClick={() => bannerInputRef.current?.click()} className="flex flex-col items-center text-white hover:text-primary-200">
                                    <UploadIcon className="h-8 w-8 text-white"/>
                                    <span className="text-sm font-semibold">Upload</span>
                                </button>
                                <button type="button" onClick={() => handleRemoveImage('banner')} className="flex flex-col items-center text-white hover:text-red-300">
                                    <TrashIcon />
                                    <span className="text-sm font-semibold">Remove</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <input type="file" accept="image/*" ref={bannerInputRef} onChange={(e) => handleImageChange(e, 'banner')} className="hidden" />
                     <div className="p-6 relative">
                        <div className="absolute -top-20 left-6">
                            <div className="w-40 h-40 rounded-full border-4 border-white bg-white relative group">
                                 <img src={editedUser.avatar || DEFAULT_AVATAR_URL} alt="User Avatar" className="w-full h-full rounded-full object-cover" />
                                 <div className="absolute inset-0 bg-black/50 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                                    <div className="flex gap-4">
                                        <button type="button" onClick={() => avatarInputRef.current?.click()} className="flex flex-col items-center text-white text-sm hover:text-primary-200">
                                            <PencilIcon className="h-5 w-5"/>
                                            <span>Edit</span>
                                        </button>
                                        <button type="button" onClick={() => handleRemoveImage('profile')} className="flex flex-col items-center text-white text-sm hover:text-red-300">
                                            <TrashIcon/>
                                            <span>Remove</span>
                                        </button>
                                    </div>
                                 </div>
                            </div>
                            <input type="file" accept="image/*" ref={avatarInputRef} onChange={(e) => handleImageChange(e, 'profile')} className="hidden" />
                        </div>
                        <div className="ml-44 pt-4 space-y-4">
                            <EditableItem label="First Name" name="firstName" value={editedUser.firstName} onChange={handleInputChange} placeholder="Your first name" />
                            <EditableItem label="Last Name" name="lastName" value={editedUser.lastName} onChange={handleInputChange} placeholder="Your last name" />
                            <EditableItem label="Role" name="description" value={editedUser.description || ''} onChange={handleInputChange} placeholder="e.g., Software Developer" />
                            <EditableItem label="Location" name="location" value={editedUser.location || ''} onChange={handleInputChange} placeholder="e.g., Chennai, India" />
                            <EditableItem label="LinkedIn" name="linkedin" value={editedUser.linkedin || ''} onChange={handleInputChange} placeholder="e.g., https://linkedin.com/in/yourprofile" />
                        </div>
                     </div>
                </Card>

                <Card className="p-6">
                    <h3 className="text-lg font-bold text-gray-800 mb-2">About</h3>
                    <EditableItem label="" name="bio" value={editedUser.bio} onChange={handleInputChange} type="textarea" placeholder="Tell us about yourself..." />
                </Card>

                <Card className="p-6">
                    <h3 className="text-lg font-bold text-gray-800 mb-4">Experience</h3>
                    <div className="space-y-6">
                    {(editedUser.experience || []).map((exp, index) => (
                        <div key={exp.id || index} className="p-4 border rounded-lg space-y-4 relative bg-gray-50/50">
                            <button type="button" onClick={() => removeListItem('experience', index)} className="absolute top-2 right-2 text-red-400 hover:text-red-600 p-1 rounded-full hover:bg-red-50"><TrashIcon /></button>
                            <EditableItem label="Title" name="title" value={exp.title} onChange={(e) => handleListChange('experience', index, e)} placeholder="e.g., Frontend Developer" />
                            <EditableItem label="Company" name="company" value={exp.company} onChange={(e) => handleListChange('experience', index, e)} placeholder="e.g., ABC Tech" />
                            <EditableItem label="Duration" name="duration" value={exp.duration} onChange={(e) => handleListChange('experience', index, e)} placeholder="e.g., 2022 - 2024" />
                            <EditableItem label="Description" name="description" value={exp.description} onChange={(e) => handleListChange('experience', index, e)} type="textarea" placeholder="Your responsibilities and achievements..." />
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Related Skills</label>
                                <div className="flex flex-wrap gap-2 mb-2">
                                    {(exp.skills || []).map(skill => (
                                        <span key={skill} className="flex items-center gap-2 bg-gray-200 text-gray-800 px-2.5 py-1 rounded-full text-xs font-medium">
                                            {skill}
                                            <button type="button" onClick={() => handleRemoveExperienceSkill(index, skill)} className="text-gray-500 hover:text-gray-700"><XCircleIcon/></button>
                                        </span>
                                    ))}
                                </div>
                                <div className="flex gap-2">
                                    <input type="text" value={newExperienceSkills[index] || ''} onChange={e => handleNewExperienceSkillChange(index, e.target.value)} placeholder="Add a related skill" className="flex-grow p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary text-sm" />
                                    <Button type="button" variant="secondary" size="sm" onClick={() => handleAddExperienceSkill(index)}>Add</Button>
                                </div>
                            </div>
                        </div>
                    ))}
                    </div>
                    <Button type="button" variant="outline" size="sm" onClick={() => addListItem('experience')} className="mt-4"><PlusIcon/>Add Experience</Button>
                </Card>

                <Card className="p-6">
                    <h3 className="text-lg font-bold text-gray-800 mb-4">Education</h3>
                     <div className="space-y-6">
                    {(editedUser.education || []).map((edu, index) => (
                        <div key={edu.id || index} className="p-4 border rounded-lg space-y-3 relative bg-gray-50/50">
                            <button type="button" onClick={() => removeListItem('education', index)} className="absolute top-2 right-2 text-red-400 hover:text-red-600 p-1 rounded-full hover:bg-red-50"><TrashIcon /></button>
                            <EditableItem label="School" name="school" value={edu.school} onChange={(e) => handleListChange('education', index, e)} placeholder="e.g., Anna University" />
                            <EditableItem label="Degree" name="degree" value={edu.degree} onChange={(e) => handleListChange('education', index, e)} placeholder="e.g., B.E" />
                            <EditableItem label="Field of Study" name="fieldOfStudy" value={edu.fieldOfStudy} onChange={(e) => handleListChange('education', index, e)} placeholder="e.g., Computer Science" />
                            <EditableItem label="Duration" name="duration" value={edu.duration} onChange={(e) => handleListChange('education', index, e)} placeholder="e.g., 2018 - 2022" />
                        </div>
                    ))}
                    </div>
                    <Button type="button" variant="outline" size="sm" onClick={() => addListItem('education')} className="mt-4"><PlusIcon/>Add Education</Button>
                </Card>

                <Card className="p-6">
                    <h3 className="text-lg font-bold text-gray-800 mb-4">Skills</h3>
                    <div className="flex flex-wrap gap-2 mb-4">
                        {(editedUser.skills || []).map(skill => (
                            <span key={skill} className="flex items-center gap-2 bg-gray-100 text-gray-700 px-3 py-1.5 rounded-full text-sm font-medium">
                                {skill}
                                <button type="button" onClick={() => handleRemoveSkill(skill)} className="text-gray-400 hover:text-gray-600"><XCircleIcon/></button>
                            </span>
                        ))}
                    </div>
                    <div className="flex gap-2">
                        <input type="text" value={newSkill} onChange={e => setNewSkill(e.target.value)} placeholder="Add a new skill" className="flex-grow p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary" />
                        <Button type="button" variant="secondary" onClick={handleAddSkill}>Add</Button>
                    </div>
                </Card>

                <Card className="p-6">
                    <h3 className="text-lg font-bold text-gray-800 mb-4">Projects</h3>
                    <div className="space-y-6">
                    {(editedUser.projects || []).map((proj, index) => (
                        <div key={proj.id || index} className="p-4 border rounded-lg space-y-3 relative bg-gray-50/50">
                            <button type="button" onClick={() => removeListItem('projects', index)} className="absolute top-2 right-2 text-red-400 hover:text-red-600 p-1 rounded-full hover:bg-red-50"><TrashIcon /></button>
                            <EditableItem label="Project Name" name="projectName" value={proj.projectName} onChange={(e) => handleListChange('projects', index, e)} placeholder="e.g., E-Commerce Platform" />
                            <EditableItem label="Project Description" name="projectDescription" value={proj.projectDescription} onChange={(e) => handleListChange('projects', index, e)} type="textarea" placeholder="Describe what the project does..." />
                            <EditableItem label="GitHub Link" name="githubLink" value={proj.githubLink} onChange={(e) => handleListChange('projects', index, e)} placeholder="e.g., https://github.com/username/repo" />
                        </div>
                    ))}
                    </div>
                    <Button type="button" variant="outline" size="sm" onClick={() => addListItem('projects')} className="mt-4"><PlusIcon/>Add Project</Button>
                </Card>
                
                <div className="p-4 flex justify-end gap-2">
                    <Button type="button" variant="secondary" onClick={handleCancel} disabled={isLoading}>Cancel</Button>
                    <Button type="submit" disabled={isLoading}>
                        {isLoading ? 'Saving...' : 'Save Changes'}
                    </Button>
                </div>

            </form>
        );
    }

    return (
        <div>
            <PageTitle title="My Profile" subtitle="Manage your personal information and settings.">
                <Button onClick={() => setIsEditing(true)}>
                    <EditIcon />
                    Edit Profile
                </Button>
            </PageTitle>

            <div className="space-y-6 mt-6">
                <Card className="overflow-hidden p-0 relative">
                    <div className="h-48 bg-gray-300">
                        <img src={bannerUrl} alt="Banner" className="w-full h-full object-cover" />
                    </div>
                    <div className="p-6 relative">
                        <img src={user.avatar || DEFAULT_AVATAR_URL} alt="User Avatar" className="w-40 h-40 rounded-full border-4 border-white absolute -top-20 bg-white object-cover" />
                        <div className="ml-44 pt-4">
                            <div className="flex justify-between items-start mb-4">
                                <h1 className="text-3xl font-bold text-gray-900 leading-tight">{user.firstName} {user.lastName}</h1>
                                <span className={`shrink-0 inline-flex items-center px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest ${user.mode === 'online' ? 'bg-blue-50 text-blue-600 border border-blue-100' : 'bg-gray-50 text-gray-600 border border-gray-200'}`}>
                                    {user.mode} Student
                                </span>
                            </div>
                            
                            <div className="flex flex-wrap items-center gap-y-3 gap-x-6">
                                {user.description && (
                                    <span className="inline-flex items-center px-3 py-1 rounded-md text-sm font-bold bg-primary-50 text-primary-700 border border-primary-100">
                                        {user.description}
                                    </span>
                                )}
                                <div className="flex items-center gap-1.5 text-sm text-gray-500 font-medium">
                                    <svg className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                                    {user.location || "No Location"}
                                </div>
                                <div className="flex items-center gap-1.5 text-sm text-gray-500 font-medium">
                                    <svg className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                                    {user.email}
                                </div>
                            </div>
                            {user.linkedin && (
                                <p className="text-sm mt-4 flex items-center gap-2">
                                    <a href={user.linkedin} target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-700 font-semibold flex items-center gap-1">
                                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5v-14c0-2.761-2.239-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-1.337-.025-3.041-1.854-3.041-1.854 0-2.138 1.45-2.138 2.944v5.701h-3v-11h2.882v1.503h.04c.402-.758 1.383-1.554 2.83-1.554 3.029 0 3.59 1.994 3.59 4.584v6.467z"/></svg>
                                        LinkedIn Profile
                                    </a>
                                </p>
                            )}
                        </div>
                    </div>
                </Card>
        
                <Card className="p-6">
                    <h2 className="text-xl font-bold text-gray-800 mb-2">About</h2>
                    <p className="text-gray-700 leading-relaxed whitespace-pre-wrap">{user.bio}</p>
                </Card>
                
                {user.experience && user.experience.length > 0 && (
                    <Card className="p-6">
                        <h2 className="text-xl font-bold text-gray-800 mb-4">Professional Experience</h2>
                        <div className="space-y-6">
                            {user.experience.map((exp, index) => (
                                <div key={exp.id || index} className="flex gap-4">
                                    <div className="w-12 h-12 bg-gray-100 rounded-md flex items-center justify-center flex-shrink-0"><CompanyIcon /></div>
                                    <div className="flex-1">
                                        <div className="flex justify-between items-start gap-4 mb-0.5">
                                            <h3 className="font-bold text-lg text-gray-900 leading-tight">{exp.title}</h3>
                                            <span className="shrink-0 text-xs font-bold text-primary-600 bg-primary-50 px-2 py-1 rounded-md">
                                                {exp.duration}
                                            </span>
                                        </div>
                                        <p className="text-sm font-medium text-gray-800">{exp.company}</p>
                                        <p className="text-sm mt-2 text-gray-600 leading-relaxed whitespace-pre-wrap">{exp.description}</p>
                                        {exp.skills && exp.skills.length > 0 && (
                                            <div className="mt-3">
                                                <h4 className="text-xs font-semibold text-gray-600">Skills:</h4>
                                                <div className="flex flex-wrap gap-1.5 mt-1">
                                                    {exp.skills.map(skill => (
                                                         <span key={skill} className="bg-gray-100 text-gray-700 px-2 py-1 rounded-md text-xs font-medium">
                                                            {skill}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Card>
                )}

                {user.education && user.education.length > 0 && (
                     <Card className="p-6">
                        <h2 className="text-xl font-bold text-gray-800 mb-4">Education</h2>
                        <div className="space-y-6">
                            {user.education.map((edu, index) => (
                                <div key={edu.id || index} className="flex gap-4">
                                    <div className="w-12 h-12 bg-gray-100 rounded-md flex items-center justify-center flex-shrink-0"><EducationIcon /></div>
                                    <div className="flex-1">
                                        <div className="flex justify-between items-start gap-4 mb-1">
                                            <h3 className="font-bold text-lg text-gray-900 leading-tight">
                                                {edu.degree}
                                                {edu.fieldOfStudy && (
                                                    <span className="block text-sm font-medium text-gray-500 mt-1 sm:inline sm:mt-0 sm:ml-2">[ {edu.fieldOfStudy} ]</span>
                                                )}
                                            </h3>
                                            <span className="shrink-0 text-xs font-bold text-primary-600 bg-primary-50 px-2 py-1 rounded-md">
                                                {edu.duration}
                                            </span>
                                        </div>
                                        <p className="text-sm font-medium text-gray-600">{edu.school} {edu.fieldOfStudy && !edu.degree && edu.fieldOfStudy}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Card>
                )}
        
                {user.skills && Array.isArray(user.skills) && user.skills.length > 0 && (
                    <Card className="p-6">
                        <h2 className="text-xl font-bold text-gray-800 mb-4">Skills</h2>
                        <div className="flex flex-wrap gap-2">
                            {user.skills.map(skill => (
                                <span key={skill} className="bg-gray-100 text-gray-700 px-3 py-1.5 rounded-full text-sm font-medium">
                                    {skill}
                                </span>
                            ))}
                        </div>
                    </Card>
                )}

                {user.projects && Array.isArray(user.projects) && user.projects.length > 0 && (
                    <Card className="p-6">
                        <h2 className="text-xl font-bold text-gray-800 mb-4">Projects</h2>
                        <div className="space-y-6">
                            {user.projects.map((proj, index) => (
                                <div key={proj.id || index} className="p-4 border rounded-lg bg-gray-50/50">
                                    <h3 className="font-bold text-lg text-gray-900">{proj.projectName}</h3>
                                    {proj.projectDescription && <p className="text-sm mt-2 text-gray-700 whitespace-pre-wrap">{proj.projectDescription}</p>}
                                    {proj.githubLink && (
                                        <a href={proj.githubLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 mt-2 text-sm text-primary hover:underline">
                                            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"/></svg>
                                            GitHub
                                        </a>
                                    )}
                                </div>
                            ))}
                        </div>
                    </Card>
                )}
            </div>
        </div>
    );
};

export default ProfilePage;